import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import { DASHBOARD_URL, MANAGE_WORKFLOWS_URL, NOTIFICATION_ERROR } from '../../constants/constant';
import { ERROR_OCCURED_TRY_AGAIN_LATER } from '../../constants/messages';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { UserTrainingDetails } from '../../models/userDetail.model';
import { TableGridHeader } from '../table-grid/table-grid.model';

@Component({
  selector: 'app-view-training',
  templateUrl: './view-training.component.html',
  styleUrls: ['./view-training.component.scss']
})
export class ViewTrainingComponent implements OnInit {

  public trainings = [];
  public trainingsHeaders: TableGridHeader[];
  public selectedTrainingData: UserTrainingDetails;
  public alert: NotificationAlert;
  public popupMessage: string;
  public loginID: number;
  showBackCPQPNavigationButton: boolean;

  constructor(private manageUsersService: ManageUsersService, private route: ActivatedRoute, private router: Router) {
    if (this.route && this.route.parent) {
      this.route.parent.params.subscribe(params => {
        this.loginID = params.id;
        this.getTrainingDetails();
      });
    }

    if(this.router.url.includes(MANAGE_WORKFLOWS_URL)) {
      this.showBackCPQPNavigationButton = true;
    }
   }

  ngOnInit(): void {
    this.trainingsHeaders = [
      {
        name: 'Date of completion',
        key: 'trainingDate',
        sortType: 'date',
        type: 'date',
      },
      { name: 'Training Name', key: 'trainingName', sortType: 'string', type: 'string' }
    ];
  }

  private getTrainingDetails(): void {
    this.manageUsersService.getTrainingData(this.loginID).subscribe((response) => {
      this.trainings = response;
      if (this.trainings.length) {
        this.manageUsersService.updateUserProfileUpdateStr.next(this.trainings[0]);
      } else {
        this.manageUsersService.updateUserProfileUpdateStr.next(null);
      }
    }, (error) => {
      this.alert = { type: NOTIFICATION_ERROR, message: `${ERROR_OCCURED_TRY_AGAIN_LATER}` };
    });
  }

  public onBackToWorkFlow(): void {
    if (this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1));
    }
  }

}
